/**
 * User: n.gorte
 * Date: 10.04.2019
 * Time: 10:40
 */
'use strict';
import { Client } from 'external/lwr-client';
import datefns from 'external/datefns';

const FIVE_MINUTE_MILLIS = 1000 * 60 * 5;

L.Control.Legend = L.Control.extend({

    onAdd(map){
        this.container = L.DomUtil.create('div', 'leaflet-bar map-legend');
        this.container.style.backgroundColor = 'white';
        this.container.style.padding = '5px 10px';

        this.timeDisplay = L.DomUtil.create('span');
        this.timeDisplay.innerHTML = 'Radardaten vom: ---';
        this.container.appendChild(this.timeDisplay);
        return this.container;

    },

    setContentString(text){
        this.timeDisplay.innerHTML = text;
    },

    error(error){
        if (error) {
            this.container.style.border = '2px solid rgba(255,0,0,0.5)';
        } else {
            this.container.style.border = '2px solid rgba(0,0,0,0.2)';
        }
    }
});

L.Control.legend = opts => new L.Control.Legend(opts);

export const FliwasRainRadarLayer = L.TileLayer.extend({

    initialize: function (url, options){ // (String, LatLngBounds, Object)
        this.timeFormat = 'dd.MM.yy HH:mm';
        this.etag = '';
        this.fetchDate = this.fetchDate.bind(this);

        this.url = this._createRequestUrl(url);
        L.TileLayer.prototype.initialize.call(this, this.url, options);

        const position = options.legendPosition || 'bottomcenter';
        this.legend = L.Control.legend({ position });

        this.fetchDate(this.getTileUrl({ x: 0, y: 0, z: 0, r: '' }));

        //check every 5 minutes
        this.intervalID = setInterval(() => {
            this.fetchDate(this.getTileUrl({ x: 0, y: 0, z: 0, r: '' }));
            this.setUrl(this.url, false);
        }, options.refreshIntervall || FIVE_MINUTE_MILLIS);

    },

    addTo(map){
        map.addControl(this.legend);
        map.addLayer(this);
        this.map = map;
        return this;
    },

    onRemove(){
        clearInterval(this.intervalID);
        this.legend.remove();
        L.TileLayer.prototype.onRemove.call(this, this.map);
    },
    _createRequestUrl(url){
        return Client.getServerUrl() + url;
    },

    fetchDate(url){
        fetch(url)
            .then((res) => {
                const etag = res.headers.get('ETag');
                this.etag = etag || this.etag;
                this.legend.error(false);
                this.legend.setContentString('Radardaten vom: ' + (this.etag ? this.etag : datefns.format(new Date(), this.timeFormat)));
            })
            .catch(e => {
                console.error('RAIN RADAR', e);
                this.legend.error(true);
                this.legend.setContentString('Radardaten konnten nicht geladen werden!');
            });
    }
});



// WEBPACK FOOTER //
// ./js/layer/FliwasRainRadarLayer.js